import { render, staticRenderFns } from "./default.md?vue&type=template&id=650541fb&"
import script from "./default.md?vue&type=script&lang=js&"
export * from "./default.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/core/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('650541fb')) {
      api.createRecord('650541fb', component.options)
    } else {
      api.reload('650541fb', component.options)
    }
    module.hot.accept("./default.md?vue&type=template&id=650541fb&", function () {
      api.rerender('650541fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "website/views/demo/Gauge/default.md"
export default component.exports